// 安全相关页面内容
export const safetyPages = {
  'is-safe': {
    h1: 'Is GB WhatsApp Safe?',
    subtitle: 'A balanced look at the real risks and benefits of using GB WhatsApp in 2026.',
    badge: 'Safety',
    sections: [
      {
        h2: 'The Short Answer',
        paragraphs: [
          'GB WhatsApp is not officially supported by WhatsApp or Meta, which means you are using modified code outside the normal security and update pipeline. That does not automatically make it dangerous — millions of people use it daily without issues — but it does mean you accept real risks around account bans, unverified APK sources, and the absence of official customer support.',
          'We do not call any mod app "100% safe," because honesty matters more than marketing. Think about how you use WhatsApp before installing: a work number that you cannot afford to lose may need stricter safety standards than a casual personal account where the extra privacy features are worth the trade-off.',
        ],
      },
      {
        h2: 'What Makes It Different from Official WhatsApp',
        list: [
          'GB WhatsApp is developed by third-party modders, not Meta',
          'It is not available on Google Play Store',
          'It modifies the original WhatsApp code to add features',
          'Meta can detect mod usage and may ban accounts',
          'Updates come from download sites, not automatic Play Store patches',
        ],
      },
      {
        h2: 'Real Risks to Know About',
        paragraphs: [
          '<strong>Account ban:</strong> WhatsApp actively detects unofficial clients and may issue temporary or permanent bans. The risk varies depending on your app version and how you use the mod — normal daily chatting is lower risk than bulk messaging or aggressive automation.',
          '<strong>APK source:</strong> Downloading from unknown websites can expose you to modified or malware-infected files disguised as GB WhatsApp. Stick to trusted sources and scan unfamiliar APKs with VirusTotal before installing. <strong>No official support</strong> means that if something goes wrong, you cannot contact WhatsApp for help — you are relying on community resources and guides like ours.',
          'For a feature-by-feature comparison with the official app, see our <a href="/gb-whatsapp-vs-whatsapp/"><strong>GB WhatsApp vs WhatsApp</strong></a> page.',
        ],
      },
      {
        h2: 'How to Use GB WhatsApp More Safely',
        list: [
          'Download only from trusted websites like this one',
          'Keep the app updated to the latest version',
          'Back up chats regularly to Google Drive',
          'Do not share sensitive banking or password info through any WhatsApp app',
          'Use anti-ban features responsibly — do not spam messages',
          'Scan the APK with VirusTotal before install if you are unsure',
        ],
      },
      {
        h2: 'GB WhatsApp vs Official — Safety Comparison',
        compareTable: {
          headers: ['Factor', 'GB WhatsApp', 'Official WhatsApp'],
          rows: [
            ['Play Store verified', 'No', 'Yes'],
            ['End-to-end encryption', 'Claims yes (modified code)', 'Yes — verified'],
            ['Account ban risk', 'Possible', 'Very low'],
            ['Official support', 'No', 'Yes'],
            ['Privacy features', 'More options', 'Standard'],
          ],
        },
        paragraphs: [
          'No messaging app is entirely risk-free — the goal is to understand the specific trade-offs and reduce avoidable problems through smart habits. If you decide the extra features are worth it, get the APK from our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a> and follow our install guide for a clean setup.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Can GB WhatsApp steal my data?',
            answer: 'Reputable GB WhatsApp builds from trusted sources have not been proven to steal data. However, because the code is modified and not open to the same scrutiny as the official app, you cannot verify its behavior with the same confidence.',
          },
          {
            question: 'Is it 100% safe?',
            answer: 'No mod app can honestly be called 100% safe. We recommend weighing the extra features against the documented risks and making a decision that fits how you actually use WhatsApp.',
          },
          {
            question: 'Does anti-ban mean zero risk?',
            answer: 'No. Anti-ban features in newer versions may reduce detection risk, but they do not eliminate it. WhatsApp continues to update its detection methods, and no mod can guarantee complete protection.',
          },
        ],
      },
    ],
  },

  'is-legal': {
    h1: 'Is GB WhatsApp Legal?',
    subtitle: 'What you should know about the legal status of using WhatsApp mods in most countries.',
    badge: 'Safety',
    sections: [
      {
        h2: 'Understanding the Legal Question',
        paragraphs: [
          'GB WhatsApp modifies WhatsApp\'s code without permission from Meta, which violates WhatsApp\'s Terms of Service. Using the mod is not typically a criminal offense in most countries, but it does place you outside the rules that govern official WhatsApp usage.',
          'This page provides general information only and is not legal advice for your specific country or situation. If you have concerns about local regulations, consult a qualified legal professional rather than relying on a download website.',
        ],
      },
      {
        h2: 'What WhatsApp\'s Terms Say',
        list: [
          'You may not reverse-engineer or modify the WhatsApp app',
          'Using unauthorized clients can result in account suspension',
          'WhatsApp does not endorse or support any third-party mods',
          'You use WhatsApp services subject to Meta\'s terms and policies',
        ],
        paragraphs: [
          'In practical terms, GB WhatsApp exists in a gray area — it is widely used around the world, but it is not officially permitted under WhatsApp\'s own rules. The most common real-world consequence is an account ban, not legal action against individual users.',
        ],
      },
      {
        h2: 'Can You Get in Legal Trouble?',
        paragraphs: [
          'For personal use, legal action against individual GB WhatsApp users is extremely rare in virtually every jurisdiction. The primary consequence you are likely to face is an account suspension or ban, not fines or criminal charges.',
          'Laws do vary by country, and business use of unauthorized clients may carry different implications in some regions. We cannot provide legal advice — if this concerns you, check your local regulations or speak with a legal professional before installing.',
        ],
      },
      {
        h2: 'GB WhatsApp vs Official — Legal Standing',
        compareTable: {
          headers: ['Aspect', 'GB WhatsApp', 'Official WhatsApp'],
          rows: [
            ['Terms of Service', 'Violates WhatsApp ToS', 'Compliant'],
            ['Play Store policy', 'Not allowed', 'Approved'],
            ['Typical consequence', 'Account ban', 'None'],
            ['Criminal risk (personal use)', 'Very low', 'None'],
          ],
        },
        paragraphs: [
          'If you decide to use GB WhatsApp despite the terms violation, download from a trusted source on our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a>. For a feature comparison with the official app, see our <a href="/gb-whatsapp-vs-whatsapp/"><strong>comparison page</strong></a>.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Is downloading GB WhatsApp illegal?',
            answer: 'Downloading APK files is legal in most regions. Using a mod that violates WhatsApp\'s terms of service is against their rules, but it is not usually against the law for personal use.',
          },
          {
            question: 'Can my employer see I use GB WhatsApp?',
            answer: 'Your employer cannot see which WhatsApp client you use from the outside. They would only see your messages if they have physical or administrative access to your phone.',
          },
        ],
      },
    ],
  },

  'ban-risk': {
    h1: 'GB WhatsApp Ban Risk – What You Need to Know',
    subtitle: 'Understand why bans happen, what triggers them, and how to lower your risk while using GB WhatsApp.',
    badge: 'Safety',
    sections: [
      {
        h2: 'Why WhatsApp Bans Mod Users',
        paragraphs: [
          'WhatsApp actively detects unofficial app versions and may issue temporary or permanent bans when it identifies mod usage. Bans are not guaranteed — many users never encounter one — but the risk is real and worth understanding before you install on an important phone number.',
          'Anti-ban updates in newer GB WhatsApp builds reduce detection risk but do not remove it entirely. No mod is truly ban-proof, and your usage habits matter as much as your app version. Normal daily chatting carries far less risk than bulk messaging, aggressive auto-replies, or frequent switching between different mod apps.',
        ],
      },
      {
        h2: 'Common Ban Triggers',
        list: [
          'Using an outdated GB WhatsApp version',
          'Sending too many messages to unknown contacts quickly',
          'Being reported by other users for spam',
          'Using aggressive auto-reply or bulk messaging',
          'Switching between different mod apps frequently',
          'Forwarding mass messages to large groups daily',
        ],
      },
      {
        h2: 'How to Lower Your Ban Risk',
        steps: [
          'Always update to the latest GB WhatsApp version immediately.',
          'Do not use GB WhatsApp for mass marketing or spam.',
          'Enable anti-ban features if available in your version.',
          'Avoid using mods on a number you cannot afford to lose.',
          'Back up chats regularly in case you need to switch to official WhatsApp.',
        ],
        paragraphs: [
          'The single most effective step is keeping your app updated — newer builds include anti-ban improvements that older versions lack. Get the newest version from our <a href="/gb-whatsapp-latest-version/"><strong>latest version download page</strong></a> and install it over your current build without uninstalling.',
        ],
      },
      {
        h2: 'Temporary vs Permanent Ban',
        compareTable: {
          headers: ['Type', 'Duration', 'What to Do'],
          rows: [
            ['Temporary ban', 'Hours to days', 'Wait for timer, update app, do not re-register'],
            ['Permanent ban', 'Forever', 'Number cannot use WhatsApp — use a new number'],
          ],
        },
        paragraphs: [
          'A temporary ban shows a countdown timer and usually lifts on its own once you wait it out and update to the latest version. A permanent ban means your number can never use WhatsApp again, which is why we recommend not using mods on numbers you cannot afford to lose.',
          'If you are already banned, read our banned account troubleshooting guide for specific next steps. For a broader comparison of how GB WhatsApp differs from the official app, see our <a href="/gb-whatsapp-vs-whatsapp/"><strong>GB WhatsApp vs WhatsApp</strong></a> page.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Does anti-ban really work?',
            answer: 'Anti-ban features in newer versions reduce detection risk but do not eliminate it entirely. Think of them as a helpful layer of protection, not a guarantee — staying updated and messaging responsibly matters more.',
          },
          {
            question: 'Will using GBWhatsApp Anti Ban version help?',
            answer: 'Updated anti-ban versions are safer than old ones, but any mod carries inherent ban risk by nature. The best approach is combining the latest build with responsible usage habits.',
          },
        ],
      },
    ],
  },

  'virus-check': {
    h1: 'GB WhatsApp Virus Check – Is the APK Clean?',
    subtitle: 'How to verify your GB WhatsApp download is safe and free from malware before you install.',
    badge: 'Safety',
    sections: [
      {
        h2: 'Are GB WhatsApp APKs Safe to Download?',
        paragraphs: [
          'The APK file itself is not a virus — it is a modified WhatsApp installer packaged for Android sideloading. The real risk comes from where you download it, since untrusted sites may bundle malware, adware, or spyware alongside the legitimate app code.',
          'A clean APK from a trusted source behaves like a normal messaging app. A tampered file may show unexpected ads, request unusual permissions, or slow down your phone after installation. Always scan unknown APK files with VirusTotal before installing, and stick to one download source you trust rather than switching between random mirrors.',
        ],
      },
      {
        h2: 'How to Check Your APK for Viruses',
        steps: [
          'Before installing, upload the APK to VirusTotal.com for a free scan.',
          'Check the file size — official builds are around 60 MB. Much smaller or larger files are suspicious.',
          'Only download from websites you trust, like our <a href="/gb-whatsapp-latest-version/"><strong>latest version page</strong></a>.',
          'Read user comments and reviews about the download source.',
        ],
      },
      {
        h2: 'Red Flags to Watch For',
        list: [
          'APK file much smaller than 50 MB',
          'Download page asks for personal info or payment',
          'App requests unusual permissions (contacts and storage are normal)',
          'Your phone slows down or shows pop-up ads after install',
          'Browser warns the file is harmful before download finishes',
        ],
      },
      {
        h2: 'What Permissions GB WhatsApp Needs',
        paragraphs: [
          'Normal permissions include contacts, storage, camera, microphone, and phone access — the same set that official WhatsApp requires to function. These are expected and necessary for messaging, media sharing, and voice calls.',
          'Be cautious if the app asks for accessibility or device admin permissions, as these are not required for a messaging app and may indicate a tampered build. Review the permission list in Android Settings after installation if anything feels off.',
        ],
      },
      {
        h2: 'GB WhatsApp vs Unknown APK Sources',
        compareTable: {
          headers: ['Source', 'Malware Risk', 'Recommendation'],
          rows: [
            ['Trusted download site', 'Low', 'Recommended'],
            ['Random forum link', 'High', 'Avoid'],
            ['Telegram channel (unknown)', 'Medium-High', 'Scan before install'],
            ['Official WhatsApp (Play Store)', 'Very Low', 'Safest option'],
          ],
        },
        paragraphs: [
          'Your download source is the single biggest factor in whether your APK is clean. Trusted sites that specialize in GB WhatsApp distribution are far safer than random forum links or unknown Telegram channels. For a broader safety comparison, see our <a href="/gb-whatsapp-vs-whatsapp/"><strong>GB WhatsApp vs WhatsApp page</strong></a>.',
        ],
      },
      {
        h2: 'Frequently Asked Questions',
        faqs: [
          {
            question: 'Does Google Play Protect block GB WhatsApp?',
            answer: 'Yes, often. Play Protect may warn about apps installed from outside the Play Store. This warning is normal for any sideloaded APK and does not necessarily mean the file is malicious — but you should still verify the source.',
          },
          {
            question: 'Should I install an antivirus app?',
            answer: 'A reputable mobile antivirus can add an extra scan layer before installation. However, downloading from trusted sources and scanning with VirusTotal is the most effective protection strategy.',
          },
        ],
      },
    ],
  },
};
